exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3jZCzfWZOdk73ZT3SZ_5l6{margin:0}._2a3K0z4qkBjHI9rljlO_m{margin:0;padding-top:.5em}._2zIDb9S1yFnTyzHqivvih3{margin-bottom:0}.K7ANuZw3AZP8byVi53AWe{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3sCsjlHZXq7C5B6Au_FRLh{padding-bottom:0;padding-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportCard_container": "Myv4QAMqt3BM2aQSCho9j",
	"ReportCard_grid": "_3jZCzfWZOdk73ZT3SZ_5l6",
	"ReportCard_item": "_2a3K0z4qkBjHI9rljlO_m",
	"ReportCard_totalScoreRow": "_2zIDb9S1yFnTyzHqivvih3",
	"ReportCard_heading": "K7ANuZw3AZP8byVi53AWe",
	"ReportCard_content": "_3sCsjlHZXq7C5B6Au_FRLh"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/ReportCard/style.postcss
// module id = 2019
// module chunks = 0